import { templatesId, type TemplatesId } from "./Templates";
import type { ColumnType, Selectable, Insertable, Updateable } from "kysely";
import { z } from "zod";

/** Identifier type for template_schemas */
export type TemplateSchemasId = string & { __flavor: "TemplateSchemasId" };

/**
 * Represents the table public.template_schemas
 * @uniqueConstraints {"template_schemas_pkey":{"name":"template_schemas_pkey","isPrimary":true,"isUnique":true,"columns":[{"name":"id","definition":"id","predicate":null}]},"schema_template_version_unique":{"name":"schema_template_version_unique","isPrimary":false,"isUnique":true,"columns":[{"name":"template_id","definition":"template_id","predicate":null},{"name":"version_major","definition":"version_major","predicate":null}]}}
 */
export default interface TemplateSchemasTable {
  id: ColumnType<TemplateSchemasId, TemplateSchemasId | undefined, TemplateSchemasId>;

  templateId: ColumnType<TemplatesId, TemplatesId, TemplatesId>;

  versionMajor: ColumnType<number | null, number | null, number | null>;

  schemaDefinition: ColumnType<unknown | null, unknown | null, unknown | null>;

  createdAt: ColumnType<Date, Date | string | undefined, Date | string>;
}

export type TemplateSchemas = Selectable<TemplateSchemasTable>;

export type NewTemplateSchemas = Insertable<TemplateSchemasTable>;

export type TemplateSchemasUpdate = Updateable<TemplateSchemasTable>;

export const templateSchemasId = z.string() as unknown as z.Schema<TemplateSchemasId>;

export const templateSchemas = z.object({
  id: templateSchemasId,
  templateId: templatesId,
  versionMajor: z.number().nullable(),
  schemaDefinition: z.unknown().nullable(),
  createdAt: z.date(),
});

export const templateSchemasInitializer = z.object({
  id: templateSchemasId.optional(),
  templateId: templatesId,
  versionMajor: z.number().optional().nullable(),
  schemaDefinition: z.unknown().optional().nullable(),
  createdAt: z.date().optional(),
});

export const templateSchemasMutator = z.object({
  id: templateSchemasId.optional(),
  templateId: templatesId.optional(),
  versionMajor: z.number().optional().nullable(),
  schemaDefinition: z.unknown().optional().nullable(),
  createdAt: z.date().optional(),
});

// ── constraints for TemplateSchemas ─────────────────────────────────
export const TemplateSchemasConstraints = {
  template_schemas_pkey: {
    name: "template_schemas_pkey",
    isPrimary: true,
    isUnique: true,
    columns: [{ name: "id", definition: "id", predicate: null }],
  },
  schema_template_version_unique: {
    name: "schema_template_version_unique",
    isPrimary: false,
    isUnique: true,
    columns: [
      { name: "template_id", definition: "template_id", predicate: null },
      { name: "version_major", definition: "version_major", predicate: null },
    ],
  },
} as const;
export type TemplateSchemasConstraintsType = typeof TemplateSchemasConstraints;
